<template>

<div class='row' id='prj-crt'>
    <div class='col-12 mb-3 text-orange text-lg-center'>       
        Общата стойност на 3-те полета може да бъде само 100%. <br /> Ако искаш да увеличиш дадена стойност е необходимо първо да намалиш някоя от другите две.       
    </div>

    <div class='col-12'>
        <label for='c-time' class="w-100 mb-1">
            <strong>Бюджетно решение: </strong>
            {{ criteria.cost }}% важност
        </label>
        <div class="rate-slider mb-3">
            <input id='c-time' @change='updateCriteria("cost")' class='custom-range pl-0 pr-0' type='range' v-model.number='criteria.cost' min=0 max=100>
            <ol class="rate-scale d-flex justify-content-between text-super-tiny pl-1 pr-1">
                <li class="mr-2">0%</li>
                <li>50%</li>
                <li>100%</li>
            </ol>
        </div>
    </div>

    <div class='col-12'>
        <label for='c-time' class="mb-1">Срок на проекта: {{ criteria.time }}%</label>
        <div class="rate-slider mb-3">
            <input id='c-time' @change='updateCriteria("time")' class='custom-range pl-0 pr-0' type='range' v-model.number='criteria.time' min=0 max=100>
            <ol class="rate-scale d-flex justify-content-between text-super-tiny pl-1 pr-1">
                <li class="mr-2">0%</li>
                <li>50%</li>
                <li>100%</li>
            </ol>
        </div>
    </div>

    <div class='col-12'>
        <label for='c-time' class="mb-1">Висока оценка на изпълнителите: ({{ criteria.rating }}%)</label>
        <div class="rate-slider mb-3">
            <input id='c-time' @change='updateCriteria("rating")' class='custom-range pl-0 pr-0' type='range' v-model.number='criteria.rating' min=0 max=100>
            <ol class="rate-scale d-flex justify-content-between text-super-tiny pl-1 pr-1">
                <li class="mr-2">0%</li>
                <li>50%</li>
                <li>100%</li>
            </ol>
        </div>
    </div>

    <div v-if='ptsLeft' class='col-12 mt-20'>
        <div class='alert alert-danger text-tiny'>
            <span class="icon icon-alert-octagon"></span>
            Моля разпределете останалите {{ ptsLeft }}%.
        </div>
    </div>

    <div v-else class="col-12 mt-3">
        <div class="alert alert-success text-tiny">
            <span class="icon icon-check"></span>
            Успешно разпределени проценти.
        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
                
            if( this.$parent.criteria ) {

                this.criteria = Object.assign( {}, this.$parent.criteria );
                this.ptsLeft = 0;

            } else {
                
                this.$parent.criteria = Object.assign( {}, this.criteria );

            }

        },

        data() {
            return {
                isReady : false,

                criteria : {
                    time : 0,
                    cost : 0,
                    rating : 0,
                },

                ptsLeft : 100
            }
        },

        methods : {

            updateCriteria( c ) {
                var max = this.getMax();

                if( this.criteria[ c ] < 0 || max > 100 ) {
                    this.autoFill( c );
                }

                this.ptsLeft = 100 - this.getMax();

                this.$parent.criteria = Object.assign({}, this.criteria);
            },

            //Sum the 3 params
            getMax() {
                return this.criteria.time + this.criteria.cost + this.criteria.rating;
            },

            autoFill( c ) {
                var v = 0;

                for( var i in this.criteria ) {
                    
                    if( i != c ) {
                        v += this.criteria[i];
                    }

                }

                this.criteria[ c ] = 100 - v;
            }

        }

    }
</script>
